/**
 * Custom Hook to retrieve Sentry DSN from Azure Key Vault
 * This ensures Sentry uses the platform secrets correctly, without breaking Lovable's architecture.
 */

import { useState, useEffect } from "react";
import { getCachedSecret } from "@/services/azure/secretsClient";
import { logger } from "@/utils/logger";
import { initSentry } from "@/config/sentry";

export const useSentryInit = () => {
  const [isSentryReady, setIsSentryReady] = useState(false);

  useEffect(() => {
    const initializeSentry = async () => {
      try {
        // Fetch Sentry DSN from Azure Key Vault
        const sentryDsn = await getCachedSecret("SENTRY-DSN");
        if (sentryDsn) {
          initSentry(sentryDsn);
          setIsSentryReady(true);
        }
      } catch (err: any) {
        logger.error(
          "Failed to fetch Sentry DSN from Azure Key Vault:",
          err
        );
      }
    };

    initializeSentry();
  }, []);

  return { isSentryReady };
};
